import React from 'react';
import cfg from '../config';

const Impressum = () => {
  return (
    <div className="container-fluid px-2 px-md-4">

      <div className="mb-4 text-center">
        <h1 className="fw-bold">Impressum</h1>
        <p className="text-muted">Angaben gemäß § 5 TMG</p>
      </div>

      <div className="accordion" id="impressumAccordion">

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#verein">
              Angaben zum Verein
            </button>
          </h2>
          <div id="verein" className="accordion-collapse collapse show">
            <div className="accordion-body">
              <p className="fw-semibold">{cfg.orgFullName}</p>
              <p>
                {cfg.orgStreet}<br />
                {cfg.orgPostal} {cfg.orgCity}
              </p>
              {(cfg.orgRegister || cfg.orgCourt) && (
                <p className="mt-3">
                  {cfg.orgRegister && <><strong>Vereinsregister:</strong> {cfg.orgRegister}<br /></>}
                  {cfg.orgCourt && <><strong>Registergericht:</strong> {cfg.orgCourt}</>}
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Vertretungsberechtigter Vorstand — bitte für eure Organisation anpassen */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#vertretung">
              Vertretungsberechtigter Vorstand
            </button>
          </h2>
          <div id="vertretung" className="accordion-collapse collapse">
            <div className="accordion-body">
              <p className="text-muted small">
                Bitte die Vorstandsmitglieder in <code>impressum.jsx</code> eintragen.
              </p>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kontakt">
              Kontakt
            </button>
          </h2>
          <div id="kontakt" className="accordion-collapse collapse">
            <div className="accordion-body">
              <p>
                {cfg.orgPhone && <><strong>Telefon:</strong> {cfg.orgPhone}<br /></>}
                {cfg.orgEmail && <><strong>E-Mail:</strong> {cfg.orgEmail}</>}
              </p>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#streit">
              Verbraucherstreitbeilegung
            </button>
          </h2>
          <div id="streit" className="accordion-collapse collapse">
            <div className="accordion-body">
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </div>
        </div>

      </div>

      <p className="text-muted small mt-4 text-center">Stand: {new Date().getFullYear()}</p>
    </div>
  );
};

export default Impressum;
